
import React, { Component } from 'react';
import { decryptValue, getData_menuExterior } from '../utils'
import { hideOperacion } from '../redux/actions';
import { connect } from 'react-redux';
import M from 'materialize-css';


class ModalFchNac extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fechaNacimiento: '',
            errorInput: false,
            dataMenuExterior: false
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const inputDate = event.target.value;
        const formattedDate = this.formatValue(inputDate);
        this.setState({ fechaNacimiento: formattedDate, errorInput: false });
    }

    formatValue(inputValue) {
        // Permitir solo números y letras (sin guiones ni otros símbolos)
        const onlyAlphaNumeric = inputValue.replace(/[^a-zA-Z0-9\-]/g, '');

        // Limitar la longitud si lo necesitas (ejemplo: 10 caracteres máx)
        const formattedValue = onlyAlphaNumeric.slice(0, 14);

        return formattedValue.toUpperCase();
    }

    componentDidMount() {

        this.getDateMenuExterior();

        M.Modal.init(document.querySelectorAll('.modalFchNac'), {
            dismissible: false,
            onOpenStart: () => {
                this.setState({
                    fechaNacimiento: '',
                    errorInput: false,
                })
            }
        });
    }

      getDateMenuExterior = async () => {
        const dataMenuE = await getData_menuExterior();
        this.setState({ dataMenuExterior: dataMenuE });
    }
    

    getMoralInvitado = () => {
         const currentCon = this.props.currentContrato;

        const invitado = currentCon.Invitado === "TRUE" ? true : false;

        const moral = decryptValue(currentCon.Moral) === "TRUE" ? true : false;

        return {moral, invitado};
    }

    getMessage = () => {

        const currentCon = this.props.currentContrato;

        if (!currentCon) return "Para acceder al documento solicitado, ingresa tu contraseña de seguridad (tu RFC sin homoclave)"

       
        const {moral, invitado} = this.getMoralInvitado();


        if (moral && invitado) {

            try {
                return this.state.dataMenuExterior.documentos.alert_moral_invitado.mensaje;
            } catch (e) {
                return "Para acceder al documento solicitado, ingresa tu contraseña de seguridad (RFC de la empresa sin homoclave)"
            }
        }

        if (moral) {

            try {
                return this.state.dataMenuExterior.documentos.alert_moral.mensaje;
            } catch (e) {
                return "Para acceder al documento solicitado, ingresa tu contraseña de seguridad (RFC de la empresa sin homoclave)"
            }
        }

        if (!invitado && !moral) {

            try {
                return this.state.dataMenuExterior.documentos.alert_fisica.mensaje;
            } catch (e) {
                return "Para acceder al documento solicitado, ingresa tu contraseña de seguridad (tu RFC sin homoclave)"
            }

        }

        if (invitado && !moral) {
            try {
                return this.state.dataMenuExterior.documentos.alert_fisica_invitado.mensaje;
            } catch (e) {
                return "Para acceder al documento solicitado, ingresa tu contraseña de seguridad (RFC del titular del contrato sin homoclave)"
            }

        }
    }


    getError = () => {

        const currentCon = this.props.currentContrato;

        if (!currentCon) return "Contraseña incorrecta"

        const {moral, invitado} = this.getMoralInvitado();

        if (moral && invitado) {

            try {
                return this.state.dataMenuExterior.documentos.alert_moral_invitado.error;
            } catch (e) {
                return "Contraseña incorrecta"
            }
        }

        if (moral) {

            try {
                return this.state.dataMenuExterior.documentos.alert_moral.error;
            } catch (e) {
                return "Contraseña incorrecta"
            }
        }

        if (!invitado && !moral) {

            try {
                return this.state.dataMenuExterior.documentos.alert_fisica.error;
            } catch (e) {
                 return "Contraseña incorrecta"
            }

        }

        if (invitado && !moral) {
            try {
                return this.state.dataMenuExterior.documentos.alert_fisica_invitado.error;
            } catch (e) {
                 return "Contraseña incorrecta"
            }

        }
    }


     getInfo = () => {

         const {moral, invitado} = this.getMoralInvitado();

        if (moral && invitado) {

            try {
                return this.state.dataMenuExterior.documentos.alert_moral_invitado.info;
            } catch (e) {
                return "Tu estado de cuenta esta protegido con contraseña"
            }
        }

        if (moral) {

            try {
                return this.state.dataMenuExterior.documentos.alert_moral.info;
            } catch (e) {
                return "Tu estado de cuenta esta protegido con contraseña"
            }
        }

        if (!invitado && !moral) {

            try {
                return this.state.dataMenuExterior.documentos.alert_fisica.info;
            } catch (e) {
                 return "Tu estado de cuenta esta protegido con contraseña"
            }

        }

        if (invitado && !moral) {
            try {
                return this.state.dataMenuExterior.documentos.alert_fisica_invitado.info;
            } catch (e) {
                 return "Tu estado de cuenta esta protegido con contraseña"
            }

        }
    }


    getPlaceHolder = () => {

         const {moral, invitado} = this.getMoralInvitado();

        if (moral && invitado) {

            try {
                return this.state.dataMenuExterior.documentos.alert_moral_invitado.ejemplo;
            } catch (e) {
                return ""
            }
        }

        if (moral) {

            try {
                return this.state.dataMenuExterior.documentos.alert_moral.ejemplo;
            } catch (e) {
                return ""
            }
        }

        if (!invitado && !moral) {

            try {
                return this.state.dataMenuExterior.documentos.alert_fisica.ejemplo;
            } catch (e) {
                 return ""
            }

        }

        if (invitado && !moral) {
            try {
                return this.state.dataMenuExterior.documentos.alert_fisica_invitado.ejemplo;
            } catch (e) {
                 return ""
            }

        }
    }

    render() {
        return (
            <div id="modalFchNac" className="modal modalFchNac">
                <div className="modal-content">
                    <div className='row'>
                        <div className='col s12 right-align'>
                            <i className='material-icons modal-close cursorPointer' onClick={() => {
                                this.props.hideOperacion();
                            }}>close</i>
                        </div>
                        <div className='col s12 center-align'>
                            <p className='ft-24'>Introduce tu contraseña</p>
                            <p className='ft-16'>
                                {this.getMessage()}
                            </p>

                        </div>
                        <div className='col s12 left-align mt-1'>
                            <label>
                                Contraseña:
                                <input
                                    type="text"
                                    value={this.state.fechaNacimiento}
                                    onChange={this.handleChange}
                                    maxLength="18" // Limitar la longitud del input para evitar que la fecha sea más larga de lo debido
                                    placeholder={this.getPlaceHolder()} // Proporcionar un indicador de formato para el usuario
                                />
                            </label>
                            {
                                this.state.errorInput ?
                                    <span class="red-text ft-10" >{this.getError()}</span>
                                    : null
                            }

                        </div>
                        <div className='col s12 left-align mt-1'>
                            <p className='ft-10' style={{ color: '#666666' }}><i className='material-icons left ft-15'>info_outline</i>  {this.getInfo()}</p>
                        </div>


                        <div className='col s12 center-align mt-2'>
                            <button className='btn primaryBtn'
                                onClick={() => {
                               
                                    const fcNacUser = decryptValue(this.props.currentContrato.RFC);

                                    if (this.state.fechaNacimiento.trim() === fcNacUser.toUpperCase()) {

                                        if (this.props.infoModalData.cb) {
                                            this.props.infoModalData.cb(this.state.fechaNacimiento.trim());
                                            M.Modal.getInstance(document.getElementById('modalFchNac')).close();
                                        }
                                    } else {
                                        this.setState({ errorInput: true });
                                    }


                                }}>
                                Confirmar Operación
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

const mapStateToProps = state => {
    let { infoModalData, dataUser, currentContrato } = false;

    if (state.commonsActions) {
        infoModalData = state.commonsActions.infoModalData || false;
    }

    if (state.servicesActions) {
        dataUser = state.servicesActions.dataUser || false;
        currentContrato = state.servicesActions.currentContrato || false
    }


    return { infoModalData, dataUser, currentContrato };
};


export default connect(mapStateToProps, { hideOperacion })(ModalFchNac);